import { authUtils } from '@/utils/auth-utils.js';
import { errorHandler } from '@/utils/helpers/error-handler.js';

export const endpointUrl = '/api/external-services';

export default {
  async createTurnCheck(payload = {}, params = {}) {
    try {
      const data = await authUtils.makeAuthenticatedRequest(
        'post',
        `${endpointUrl}/turn-ai/checks`,
        payload,
        params,
      );
      return data;
    } catch (err) {
      errorHandler('createTurnCheck', err);
    }
  },

  async updateTurnCheck(checkId, payload = {}, params = {}) {
    try {
      const data = await authUtils.makeAuthenticatedRequest(
        'put',
        `${endpointUrl}/turn-ai/checks/${checkId}`,
        payload,
        params,
      );
      return data;
    } catch (err) {
      errorHandler('updateTurnCheck', err);
    }
  },

  async getClearStarAccessToken(params = {}) {
    try {
      const data = await authUtils.makeAuthenticatedRequest(
        'get',
        `${endpointUrl}/clear-star/token`,
        null,
        params,
      );
      return data;
    } catch (err) {
      errorHandler('getClearStarAccessToken', err);
    }
  },
};
